import { render } from "./TheActiveStatus.vue?vue&type=template&id=1b46e885"
import script from "./TheActiveStatus.vue?vue&type=script&lang=js"
export * from "./TheActiveStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__